import axiosInstance from '../axiosInstance';
import { toast } from 'sonner';

// ── Action Types ──────────────────────────────────────────────────────────────
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
export const FETCH_NOTIFICATIONS_LOADING = 'FETCH_NOTIFICATIONS_LOADING';
export const MARK_READ = 'MARK_READ';
export const MARK_ALL_READ = 'MARK_ALL_READ';
export const SET_UNREAD_COUNT = 'SET_UNREAD_COUNT';

// ── Fetch notifications ───────────────────────────────────────────────────────
export const Fetch_Notifications =
  (includeRead = false, company_id = 0) =>
  async (dispatch) => {
    dispatch({ type: FETCH_NOTIFICATIONS_LOADING });
    try {
      const res = await axiosInstance.get(`payment-schedules/notifications?include_read=${includeRead}&limit=60&company_id=${company_id}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      if (res.data.success) {
        dispatch({ type: FETCH_NOTIFICATIONS_SUCCESS, payload: res.data.data });
      }
    } catch (err) {
      console.error('Fetch notifications error:', err);
    }
  };

// ── Mark single as read ───────────────────────────────────────────────────────
export const Mark_Notification_Read = (id) => async (dispatch) => {
  try {
    await axiosInstance.put(
      `payment-schedules/notifications/${id}/read`,
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    dispatch({ type: MARK_READ, payload: id });
  } catch (err) {
    console.error('Mark read error:', err);
  }
};

// ── Mark all as read ──────────────────────────────────────────────────────────
export const Mark_All_Read = () => async (dispatch) => {
  try {
    await axiosInstance.put(
      `payment-schedules/notifications/read-all`,
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    dispatch({ type: MARK_ALL_READ });
    toast.success('All notifications marked as read');
  } catch (err) {
    console.error('Mark all read error:', err);
  }
};

// ── Upsert payment schedule (call after create/update purchase or sale) ───────
export const Upsert_Payment_Schedule = (data) => async () => {
  try {
    await axiosInstance.post(`payment-schedules/upsert`, data, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
  } catch (err) {
    console.error('Upsert schedule error:', err);
  }
};

// ── Mark schedule as paid ─────────────────────────────────────────────────────
export const Mark_Schedule_Paid = (id) => async (dispatch) => {
  try {
    await axiosInstance.put(`payment-schedules/${id}/paid`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
    toast.success('Payment schedule marked as paid');
    dispatch(Fetch_Notifications());
  } catch (err) {
    console.error('Mark paid error:', err);
  }
};
